/**
 * SkipLink — premier élément focusable du shell.
 * Invisible jusqu'au focus clavier (Tab depuis le début de page).
 *
 * Cible : <main id="main" tabIndex={-1}> dans <AppShell>.
 */

import { useTranslation } from "react-i18next";

export function SkipLink() {
  const { t } = useTranslation();
  return (
    <a
      href="#main"
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-[color:var(--brand-primary)] focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-[color:var(--brand-primary-foreground)] focus:shadow-lg focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
    >
      {t("a11y.skip_to_main")}
    </a>
  );
}
